import { messages, translate } from '../i18n/messages';

export function displayName(profile) {
  if (!profile) return '—';
  const joined = [profile.first_name, profile.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();
  return joined || profile.full_name || translate('common.unnamed');
}

export function vehicleTitle(vehicle) {
  if (!vehicle) return '—';
  const parts = [vehicle.brand, vehicle.model, vehicle.year]
    .filter((part) => part !== null && part !== undefined && `${part}`.trim() !== '');
  return parts.join(' ') || translate('common.vehicle');
}

export function localeTag() {
  const lang = typeof document !== 'undefined' ? document.documentElement.lang : '';
  if (lang === 'ar') return 'ar-EG';
  if (lang === 'en') return 'en-GB';
  return undefined;
}

export function money(value, digits = 0) {
  if (value === null || value === undefined || value === '') return '—';
  const amount = Number(value);
  if (Number.isNaN(amount)) return '—';
  return new Intl.NumberFormat(localeTag() || 'en-EG', {
    style: 'currency',
    currency: 'EGP',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(amount);
}

export function formatWhen(value) {
  if (!value) return '—';
  return new Intl.DateTimeFormat(localeTag(), {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function formatDate(value) {
  if (!value) return '—';
  return new Intl.DateTimeFormat(localeTag(), { dateStyle: 'medium' }).format(
    new Date(value)
  );
}

export const bookingStatuses = [
  'pending',
  'confirmed',
  'checked_in',
  'in_progress',
  'completed',
  'cancelled',
];

const STATUS_LABELS = {
  pending: 'Pending',
  confirmed: 'Confirmed',
  checked_in: 'Checked in',
  in_progress: 'In progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export function statusLabel(status) {
  const lang = typeof document !== 'undefined' ? document.documentElement.lang : 'en';
  const table = messages[lang] || messages.en;
  const key = `status.${status}`;
  return table[key] || messages.en[key] || STATUS_LABELS[status] || (status || '').replaceAll('_', ' ');
}

export function staySummary(row) {
  if (!row) return '—';
  const parts = [row.stay_option === 'wait' ? translate('stay.wait') : translate('stay.leave')];
  if (row.pickup_delivery) parts.push(translate('stay.pickup'));
  if (row.estimated_minutes) parts.push(translate('stay.minutes', { n: row.estimated_minutes }));
  return parts.join(' · ');
}

export { serviceIcons, serviceIcon } from './serviceIcons';
